/**
 * MegaRTL Contact Form - Section specific interactions
 */

(function () {
    function initContactForm() {
        const contactForm = document.getElementById('ContactForm');
        if (contactForm) {
        }
    }

    document.addEventListener('DOMContentLoaded', initContactForm);
    document.addEventListener('shopify:section:load', (event) => {
        if (event.target.querySelector('.section-contact-form')) {
            initContactForm();
        }
    });
})();
